import angular from 'angular';

let InsuranceListController = function (Insurance, $filter, $scope, $state, $mdDialog, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    edit, orderList, handleDelete, onChangeState, onChangeCity
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'name',
      like_search: '',
      like_search_fields: [
        'name'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      Insurance.listStates().then(function (states) {
        $ctrl.state_id = states[0].sigla
        $ctrl.states = states;
        Insurance.listCities($ctrl.state_id).then(function (cities) {
          $ctrl.city_id = cities[0].sigla
          $ctrl.cities = cities;
          loadData($ctrl.city_id)
        })
      })
    }, true);
  }

  function onChangeCity(cityId) {
    loadData($ctrl.city_id)
  }
  function onChangeState(stateId) {
    $ctrl.city_id = undefined;
    $ctrl.loadingCities = true;

    Insurance.listCities($ctrl.state_id)
      .then(cities => {
        $ctrl.cities = cities;
        $ctrl.loadingCities = false;
        $ctrl.resources = []
      })
      .catch(err => {
        console.log('err:', err);
        $ctrl.loadingCities = false;
      });
  }
  function edit(resource) {
    resource.city_id = $ctrl.city_id;
    const id = resource.id;
    localStorage.setItem('insurance', JSON.stringify(resource))
    $state.go('insurance.edit', {id});
  }

  function handleDelete({id}, event) {
    event.stopPropagation();

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('common-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('common-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    const obj = {
      id: id,
      sigla_uf: $ctrl.state_id,
      sigla_city: $ctrl.city_id
    }

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Insurance
          .deleteCovenant(obj)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            loadData($ctrl.city_id);
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData(sigla) {
    $ctrl.promise = Insurance
      .load(sigla, $ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.description === null || item.description === undefined) {
  			item.description = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

InsuranceListController.$inject = ['Insurance', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];

export default InsuranceListController;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-list.controller.js